import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="arcs-dark w-full border-y-4 border-coral bg-night" data-id="element-79" data-mp="1zyh2w7skw2x2">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center sm:py-20" data-id="element-80" data-mp="1uxteltvqi06j">
        <h2 className="lane-underline font-display text-[30px] leading-tight text-sand sm:text-5xl" data-id="element-81" data-mp="1pz8gc001lqkq">
          Stop rebuilding acro class.{' '}
          <span className="text-coral" data-id="element-82" data-mp="1l16u567blb51">Walk in ready.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-sand/80" data-id="element-83" data-mp="1g8wzjcv9fmwf">
          A full year of acro classes, partner flows, jams, workshops and
          retreat sessions, planned for mixed levels — with the spot, the way
          down and the easier version already written for every pose. Open,
          print, teach.
        </p>

        <div className="mt-7" data-id="element-84" data-mp="128chwk12zx4i">
          <Countdown size="sm" tone="dark" data-id="element-85" data-mp="12brzpum53k9m" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-3xl border border-coral bg-coral/10 px-5 py-4 text-left" data-id="element-86" data-mp="xbm463cr1dm9">
          <div data-id="element-87" data-mp="40hcft2pyqyh">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-coral" data-id="element-88" data-mp="40zgvczjcbhh">
              Complete package
            </span>
            <span className="text-[15px] font-bold text-sand" data-id="element-89" data-mp="3lj2406m0kw6n">
              Acro Yoga Class Ready — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-90" data-mp="i08xgdrnl7lz">
            <span className="text-[15px] text-sand/60 line-through" data-id="element-91" data-mp="hyo3ap993qon">$69</span>
            <span className="font-display text-4xl leading-none text-sand" data-id="element-92" data-mp="mytxod6wnraf">
              $27
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-93" data-mp="d15quow0ytbw">
          <CtaButton data-id="element-94" data-mp="czungq6hrnlb">Yes, I want my classes planned — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-sand/65" data-id="element-95" data-mp="2srs9m6yq7j8r">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-96" data-mp="147mf0h1l5zfk">
                <span className="h-1.5 w-1.5 rounded-full bg-coral" data-id="element-97" data-mp="za2ytblbvckz" />
                {item}
              </li>)}
        </ul>
      </div>
    </section>;
}